import React,{useState,useEffect,useContext} from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import SharedDataContext from "../../_helper/SharedData";
import CommonModal from "../../CommonElements/CommonModal/index";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CorprateForms from "../FormsTariff/CorprateForms";
// import { getCorporateClientsList, getCorporateClientsListByFilter, getCorporateClientsListBySearch } from "../../Services/CorporateClient.service";
import PackagesForms from "../FormsTariff/PackagesForms";
import PackagesRatesForms from "../FormsTariff/PackagesRatesForms";
import CustomTabs from '../../CommonElements/CommonTabs/CustomTabs'
import CommonFormPage from '../../CommonElements/CommonFormPage/CommonFormPage'
import PackageRates from '../../Components/PackageRates/index'
import CustomPackageRates from "../CutomPackageRates/CustomPackageRates";
import PackageRatesTable from "../FormsTariff/PackageRatesTable";
import {
  getTaxGroupList,
} from "../../Services/Packages.service";

function CorprateClientFlow({setTitle}) {

  const { cityData, globalCityField, setShowApiLoader } = useContext(SharedDataContext);
  const [editId, setEditId] = useState("")
  const [createdPackage, setCreatedPackage] = useState({})
  const [newCorp,setNewCorp] = useState({});
  const [isForm,setForm] = useState(true);
  const[packId,setPackId] = useState();
  const[newFlow,setNewFlow] = useState(true);
  const[combinedTax,setCombinedTax] = useState([])


  const handleNewExistFlow=()=>{
    setNewFlow(!newFlow);
  }
  
  function generateTaxCombinationsForSelectBox(taxData) {
    const combinations = [];
  
    taxData.forEach(baseTax => {
        taxData.forEach(serviceTax => {
            const label = `Base ${baseTax.value.taxPercentage=== "12%" ?"6%":"0%"} Service ${serviceTax.value.taxPercentage=== "12%" ?"6%":"0%"}`;
            const value = {
                baseTax: baseTax.value,
                serviceTax: serviceTax.value
            };
            combinations.push({ label, value });
        });
    });
  
    return combinations;
  }
  
  useEffect(()=>{
    setForm(true)
    getTaxGroupList().then((result) => {
      if (result.status == 200) {
          const data = result.data.map((element) => {
              return {
                  value: element,
                  label: element.name,
              };
          });
        
          setCombinedTax(generateTaxCombinationsForSelectBox(data));

      }
  });
  },[])

  useEffect(()=>{
    console.log("packId changed",packId)
  },[packId])

  const handleFormFlow = ()=>{
    setForm(!isForm)
  }

  const tabs = [
    
    { label: 'Corporate Client',content:<CorprateForms cityData={cityData} editId={editId} setCorprateClient={setNewCorp} taxArr={combinedTax}/> },
    { label: 'Package',content:<PackagesForms cityData={cityData} corprateClient={newCorp} setCreatedPackage={setCreatedPackage} setPackId={setPackId} newFlow={newFlow} setNewFlow={setNewFlow}  taxArr={combinedTax} setTitle={setTitle}/> },
    { label: 'Package Rates',content:newFlow?<PackagesRatesForms  setTitle={setTitle} createdPackage={createdPackage}/>:<PackageRatesTable   packId={packId}/> },
    
  ]

  return (
    <div>
      {/* {isForm?
     <CommonFormPage setForm={setForm} setEditId={setEditId} setNewFlow={setNewFlow} setTitle={setTitle}/> */}
      <CustomTabs tabs={tabs} />
    </div>
  );
}

export default CorprateClientFlow;